import { GenericType } from "./props";

const EmployeeLeaveTypes: GenericType[] = [
    { key: "annual leave", text: "Annual Leave (Deducts Quota)" },
    { key: "wfh", text: "Work From Home (Deducts WFH Quota)" },
    { key: "sick leave", text: "Sick Leave (Attach Medical Certificate)" },
    { key: "maternity leave", text: "Maternity Leave (Special)" },
    { key: "marriage leave", text: "Marriage Leave (Special)" },
    { key: "bereavement leave", text: "Bereavement Leave (Special)" },
    { key: "others", text: "Other Special Leave" }
];

export default EmployeeLeaveTypes;
